import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { useCallback, useContext, useState } from 'react';
import { Text } from "../Text";
import { ComboBoxContext } from "./ComboBoxContext";
import styled from 'styled-components';
import { theme } from "../../theme";
import { usePrevious } from "../../hooks";
import { easeCurves } from "../../motion/eases";
export var ComboBoxItemText = React.forwardRef(function (_ref, forwardedRef) {
  var text = _ref.children,
      other = _objectWithoutProperties(_ref, ["children"]);

  var _useContext = useContext(ComboBoxContext),
      query = _useContext.query;

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      highlightRectWidth = _useState2[0],
      setHighlightRectWidth = _useState2[1];

  var previousHighlightWidth = usePrevious(highlightRectWidth);
  var measuredRef = useCallback(function (node) {
    if (node !== null) {
      setHighlightRectWidth(node.offsetWidth);
    }
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [query]);
  var regexQuery = new RegExp(escapeQueryForRegex(query), 'i'); // TODO revisit the animation of highlighting multiple items with matchAll().
  // [...text.matchAll(regexQuery)]
  // make sure we only search for this if query length is > 0

  var found = query.length > 1 ? text.match(regexQuery) : null;
  var prefix = text === null || text === void 0 ? void 0 : text.slice(0, found ? found.index : text.length);
  var suffix = found ? text.slice(found.index + query.length) : null;
  return /*#__PURE__*/React.createElement(Text, _extends({
    ref: forwardedRef
  }, other), prefix, /*#__PURE__*/React.createElement(HighlightWrapper, null, /*#__PURE__*/React.createElement(Highlight, {
    style: {
      width: "".concat(highlightRectWidth, "px")
    },
    $hasMatch: !!found,
    $previousWidth: previousHighlightWidth
  })), /*#__PURE__*/React.createElement(HighlightMark, {
    ref: measuredRef
  }, found === null || found === void 0 ? void 0 : found[0]), suffix);
});

function escapeQueryForRegex(query) {
  // return the escaped character to be used in a regex().
  return query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

export var HighlightMark = styled.mark.withConfig({
  displayName: "ComboBoxItemText__HighlightMark",
  componentId: "vapor__sc-4uxb2n-0"
})(["position:relative;color:", ";background-color:transparent;"], theme.colors.palette.grey100);
var HighlightWrapper = styled.span.withConfig({
  displayName: "ComboBoxItemText__HighlightWrapper",
  componentId: "vapor__sc-4uxb2n-1"
})(["position:relative;display:inline;align-items:center;justify-content:center;"]);
export var Highlight = styled.span.withConfig({
  displayName: "ComboBoxItemText__Highlight",
  componentId: "vapor__sc-4uxb2n-2"
})(["position:absolute;display:block;top:0px;left:0px;width:0px;height:100%;background-color:", ";transform-origin:center center;transition-property:opacity,transform ", ";transition-timing-function:", ";", ""], theme.colors.palette.whiteA20, function (p) {
  return p.$previousWidth !== 0 && ", width";
}, easeCurves.easeInOutQuint, function (p) {
  return p.$hasMatch ? "transition-duration: 0.15s;\n      opacity: 1;\n      transform: scale(1.0, 1.0);\n      " : "transition-duration: 0s;\n      opacity: 0;\n      transform: scale(1.0, 2.0);\n      ";
});